/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Practice_Suggested_AnswerInputs */

const en_interview_practice_suggested_answer = /** @type {(inputs: Interview_Practice_Suggested_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggested Stronger Answer`)
};

const de_interview_practice_suggested_answer = /** @type {(inputs: Interview_Practice_Suggested_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorgeschlagene bessere Antwort`)
};

const fr_interview_practice_suggested_answer = /** @type {(inputs: Interview_Practice_Suggested_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réponse suggérée plus forte`)
};

const es_interview_practice_suggested_answer = /** @type {(inputs: Interview_Practice_Suggested_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respuesta sugerida más sólida`)
};

const it_interview_practice_suggested_answer = /** @type {(inputs: Interview_Practice_Suggested_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risposta suggerita più efficace`)
};

const nl_interview_practice_suggested_answer = /** @type {(inputs: Interview_Practice_Suggested_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voorgesteld sterker antwoord`)
};

const pl_interview_practice_suggested_answer = /** @type {(inputs: Interview_Practice_Suggested_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sugerowana mocniejsza odpowiedź`)
};

const fi_interview_practice_suggested_answer = /** @type {(inputs: Interview_Practice_Suggested_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ehdotettu vahvempi vastaus`)
};

const da_interview_practice_suggested_answer = /** @type {(inputs: Interview_Practice_Suggested_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foreslået stærkere svar`)
};

const sv_interview_practice_suggested_answer = /** @type {(inputs: Interview_Practice_Suggested_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Föreslaget starkare svar`)
};

/**
* | output |
* | --- |
* | "Suggested Stronger Answer" |
*
* @param {Interview_Practice_Suggested_AnswerInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_practice_suggested_answer = /** @type {((inputs?: Interview_Practice_Suggested_AnswerInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Practice_Suggested_AnswerInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_practice_suggested_answer(inputs)
	if (locale === "fr") return fr_interview_practice_suggested_answer(inputs)
	if (locale === "es") return es_interview_practice_suggested_answer(inputs)
	if (locale === "it") return it_interview_practice_suggested_answer(inputs)
	if (locale === "nl") return nl_interview_practice_suggested_answer(inputs)
	if (locale === "pl") return pl_interview_practice_suggested_answer(inputs)
	if (locale === "fi") return fi_interview_practice_suggested_answer(inputs)
	if (locale === "da") return da_interview_practice_suggested_answer(inputs)
	if (locale === "sv") return sv_interview_practice_suggested_answer(inputs)
	return en_interview_practice_suggested_answer(inputs)
});